import {Component, Input, inject} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {TYPE} from "../../../shared/types/types";
import {DocumentService} from "../../../shared/services/document.service";

@Component({
    selector: 'app-item-documents-preview-uploading',
    imports: [
        NgOptimizedImage
    ],
    templateUrl: './item-documents-preview-uploading.component.html',
    styleUrl: './item-documents-preview-uploading.component.scss'
})
export class ItemDocumentsPreviewUploadingComponent {
  public documentService: DocumentService = inject(DocumentService);


  @Input() public file: TYPE.Document | null = null;

}
